import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: (localStorage.getItem("token")) || false,
  isLoggedIn: (localStorage.getItem("token")) ? true : false,
  darkMode: false,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state) => {
      state.isLoggedIn = true;
      state.userId = (localStorage.getItem("token"));
    },

    logout: (state) => {
      state.isLoggedIn = false;
      state.userId = false;
      localStorage.removeItem("token");
      localStorage.removeItem("dus");
    },
    changeMode: (state) => {
      state.darkMode = !state.darkMode;
      if (state.darkMode) {
        document.querySelector("html").setAttribute("data-theme", "dark");
      } else {
        document.querySelector("html").setAttribute("data-theme", "winter");
      }
    },
  },
});
export const { login, logout, changeMode } = AuthSlice.actions;

export default AuthSlice.reducer;
